import { MarketingClient } from 'clients';

export const getSections = async ({ q = {}, ...restProps }) => {
  const result = MarketingClient.getSections({ q, ...restProps });
  return result;
};

export default { getSections };
